import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface IRootProps {
  hoverBackgroundColor?: string | undefined;
}

export const Root = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  &:hover {
    background-color: ${(props: IRootProps) => (props.hoverBackgroundColor ? props.hoverBackgroundColor : C.LIGHTER_GRAY)};
  }
`

export const CircleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
`